

export const getTotalTimeListened = (data) => {
    const totalMs = data.reduce((sum, entry) => sum + entry.msPlayed, 0);
    return formatTime(totalMs);
}

export const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
}